import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"clear-formatting-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22.2739 11.5454L14.0312 3.30273L5.78857 11.5454L14.0312 19.788L22.2739 11.5454Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.78828 11.5454L14.0309 3.30273L22.2736 11.5454L14.0309 19.788M5.78828 11.5454L14.0309 19.788M5.78828 11.5454L3.78835 13.5456C2.61678 14.7171 2.61677 16.6166 3.78835 17.7882L7.16212 21.162L12.6572 21.162M14.0309 19.788L12.6572 21.162M12.6572 21.162H18.9998","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ClearFormatting1 = Vue.extend<IconProps>({
  name: 'ClearFormatting1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'clear-formatting-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ClearFormatting1;
